import { c as _c } from "react/compiler-runtime";
import PhoneNumberField from 'components/consumer/checkout/desktop/components/Shipping/components/PhoneNumberField';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Radio from 'components/essentials/Radio';
const preferredContactTime = ['Morning', 'Afternoon', 'Evening'];
const preferredContactTimeZone = ['Eastern', 'Central', 'Mountain', 'Pacific'];
const PreferredContactTimeChoices = t0 => {
  const $ = _c(16);
  const {
    onChange,
    options,
    optionName,
    label,
    selectedValue
  } = t0;
  let t1;
  if ($[0] !== onChange || $[1] !== optionName || $[2] !== options || $[3] !== selectedValue) {
    let t2;
    if ($[5] !== onChange || $[6] !== optionName || $[7] !== selectedValue) {
      t2 = element => <div><Radio name={`${optionName}-${element}`} checked={selectedValue === element} onChange={() => onChange(optionName, element)}>{element}</Radio></div>;
      $[5] = onChange;
      $[6] = optionName;
      $[7] = selectedValue;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    t1 = options.map(t2);
    $[0] = onChange;
    $[1] = optionName;
    $[2] = options;
    $[3] = selectedValue;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const choices = t1;
  let t2;
  if ($[9] !== label) {
    t2 = <div className="font-bold text-base mb-2">{label}</div>;
    $[9] = label;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== choices) {
    t3 = <div className="flex flex-wrap gap-x-3 ml-2">{choices}</div>;
    $[11] = choices;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== t2 || $[14] !== t3) {
    t4 = <>{t2}{t3}</>;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
};
const CustomerContactOption = ({
  onChange,
  yearsSinceOrderDelivered = 0
}) => {
  const [contactOption, setContactOption] = useState('email');
  const [phonePreferredTime, setPhonePreferredTime] = useState({
    phoneNumber: '',
    preferredContactTime: preferredContactTime[0],
    preferredContactTimeZone: preferredContactTimeZone[0]
  });
  const handlePhoneNumberChange = e => {
    const timeSelection = phonePreferredTime;
    timeSelection.phoneNumber = e.target.value;
    setPhonePreferredTime(timeSelection);
    onChange({
      phone: timeSelection
    });
  };
  const handlePreferredContactChange = (optionName, value) => {
    phonePreferredTime[optionName] = value;
    setPhonePreferredTime(phonePreferredTime);
    onChange({
      phone: phonePreferredTime
    });
  };
  return <div className="CustomerContactOption mt-4">
      <p className="font-bold text-base mb-2">
        How would you like us to contact you?
      </p>

      <div className="flex flex-row items-center gap-3">
        <Radio name="contact-option" checked={contactOption === 'email'} onChange={() => {
        onChange(null);
        setContactOption('email');
      }}>
          Email
        </Radio>

        <Radio name="contact-option" checked={contactOption === 'phone'} onChange={() => {
        setContactOption('phone');
        onChange({
          phone: phonePreferredTime
        });
      }}>
          Phone
        </Radio>
      </div>

      {contactOption === 'phone' && <PhoneNumberField value={phonePreferredTime.phoneNumber} handleChange={handlePhoneNumberChange} handleBlur={handlePhoneNumberChange} placeholder="Phone number" />}
      {contactOption === 'phone' && yearsSinceOrderDelivered < 11 && <div>
          <PreferredContactTimeChoices onChange={handlePreferredContactChange} options={preferredContactTime} optionName="preferredContactTime" label="What is your preferred contact time?" selectedValue={phonePreferredTime.preferredContactTime} />
          <PreferredContactTimeChoices onChange={handlePreferredContactChange} options={preferredContactTimeZone} optionName="preferredContactTimeZone" label="What timezone are you located in?" selectedValue={phonePreferredTime.preferredContactTimeZone} />
        </div>}
    </div>;
};
CustomerContactOption.propTypes = {
  onChange: PropTypes.func.isRequired,
  yearsSinceOrderDelivered: PropTypes.number
};
export default CustomerContactOption;